import React from 'react';
import { useWabaMessageList } from './store';
import { Badge, Button, Pagination, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';
const { Text, Title } = Typography;

const WABAList = ({ setWaba, waba, setPage }) => {
    const { wabaList, pageCount } = useWabaMessageList();

    return (
        <div>
            {wabaList.map((_waba, index) => (
                <Badge.Ribbon text={_waba.message_count} color='green'>
                    <div>
                        <div key={_waba._id} className={`d-flex justify-content-between align-items-center border px-3 py-2 pe-5 ${index === wabaList.length-1 ? '': 'border-bottom-0'}`}>
                            <div className='d-flex flex-column'>
                                <div><Title level={5} style={{ margin: 0 }} className={waba?._id === _waba._id ? 'text-primary': ''}>{(_waba.template_id)}</Title></div>
                                <div className='fst-italic'><Text type="secondary">Key : {_waba.key}</Text></div>
                            </div>
                            <Button type='primary' shape='circle' onClick={() => setWaba(_waba)}>
                                <RightOutlined />
                            </Button>
                        </div>
                    </div>
                </Badge.Ribbon>
            ))}
            <div className='d-flex justify-content-around'>
                <Pagination showSizeChanger={false} className='pt-4' defaultCurrent={1} onChange={(pageno) => setPage(pageno)} total={pageCount} />
            </div>
        </div>
    );
};

export default WABAList;


